<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Novo estorno"
    >
        <rkm-form v-if="model">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidades"
                        disabled
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.salasVacinacao"
                        disabled
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.salaVacinacaoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-table
                        :fields="fields"
                        :items="model.vacinas"
                    >
                        <template v-slot:cell(selecionado)="row">
                            <rkm-form-checkbox v-model="row.item.selecionada" />
                        </template>
                    </rkm-table>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
                color="secondary"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {
            const fields = [{ class: 'col-min', key: 'selecionado', label: '#' }]

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    fields.push({ key: 'vacinaSigla', label: 'Sigla da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina' })
                    break;

                default:
                    fields.push({ key: 'vacinaNome', label: 'Nome da vacina' })
                    break;
            }

            fields.push(
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'lote', label: 'Lote' },
                { key: 'dataValidadeLote', label: 'Validade do lote' }
            )

            return fields
        },
    },
    created() {
        this.repositories = {
            entrada: this.getConectaSusRepository('imunizacao.entrada'),
        }
    },
    data: () => ({
        additionals: null,
        enums: { parametrizacaoDescricaoVacina },
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.$refs.RkmModal.show()
            this.load(item)
        },
        load(item) {
            const request = {
                tipoMovimentacao: 'estorno',
                entradaId: item.id,
            }

            this.setLoading()

            this.repositories.entrada.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            const vacinas = this.model.vacinas.filter(vacina => vacina.selecionada === true)

            if (vacinas.length === 0) {
                this.showValidationNotification('Obrigatório selecionar pelo menos uma vacina.')
                return
            }

            const request = {
                tipoMovimentacao: 'estorno',
                salaVacinacaoId: this.model.salaVacinacaoId,
                vacinas: vacinas.map(vacina => vacina.id),
            }

            this.setLoading()

            this.repositories.entrada.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.showSaveNotification()
                    this.handleExit()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit() {
            this.$emit('save')
            this.$refs.RkmModal.hide()
        },
    },
    mixins: [ error, repository, stringCase ],
}
</script>